module.exports = __webpack_public_path__ + "img/bulk-minus-icon.26afdb32.svg";